/* eslint-disable max-len */
import { SvgIcon, colors } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import { noop } from 'lodash';
import * as React from 'react';

const Contact: React.FC<CustomSvgIcon> = ({
    id = '',
    className = '',
    iconColor = `${colors.common.black}`,
    onClick = noop
}) => {
    return (
        <SvgIcon
            className={className}
            id={id}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 12 12'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Contact</title>
                <path
                    clipRule='evenodd'
                    d='M9.94609 10.1642C8.91927 11.1402 7.52816 11.7373 5.99974 11.7373C4.70727 11.7373 3.51325 11.3105 2.55205 10.588C2.5251 10.4388 2.50732 10.2835 2.50732 10.1282C2.50732 8.49844 4.17306 7.17902 6.22671 7.17902C8.28036 7.17902 9.94609 8.49844 9.94609 10.1282V10.164V10.1642ZM6.22651 2.07458C7.45042 2.07458 8.43837 3.06274 8.43837 4.28645C8.43837 5.51016 7.45022 6.49538 6.22651 6.49538C5.0028 6.49538 4.01758 5.50723 4.01758 4.28645C4.01758 3.06567 5.00573 2.07458 6.22651 2.07458Z'
                    fill={iconColor}
                    fillRule='evenodd'
                />
                <path
                    d='M6 0C7.65675 0 9.15821 0.671723 10.2448 1.75812C11.3285 2.84472 12 4.34325 12 6C12 7.65675 11.3283 9.15821 10.2448 10.2448C9.15821 11.3285 7.65675 12 6 12C4.34325 12 2.84472 11.3283 1.75812 10.2448C0.671723 9.15821 0 7.65675 0 6C0 4.34325 0.671723 2.84472 1.75812 1.75812C2.84472 0.671723 4.34325 0 6 0ZM9.87174 2.13139C8.88066 1.14031 7.51358 0.528355 6 0.528355C4.48642 0.528355 3.11934 1.14031 2.13139 2.13139C1.14031 3.11954 0.528355 4.48955 0.528355 6C0.528355 7.51045 1.14031 8.88066 2.13139 9.87174C3.11954 10.8628 4.48955 11.4748 6 11.4748C7.51045 11.4748 8.88066 10.8628 9.87174 9.87174C10.8628 8.88066 11.4748 7.51358 11.4748 6C11.4748 4.48642 10.8628 3.11934 9.87174 2.13139Z'
                    fill={iconColor}
                />
            </svg>
        </SvgIcon>
    );
};

export default Contact;